import { classes } from "lib/actions/util";
import React from "react";
import { ButtonProps } from "react-html-props";

const ButtonCard = ({
  className,
  children,
  ...rest
}: ButtonProps & {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <button
      type="button"
      className={classes(
        "cursor-pointer rounded-md border border-gray-200 bg-white hover:bg-neutral-50",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default ButtonCard;
